import { useState } from "react";
import { useTranslation } from "react-i18next";

import TasksProvider, { useTasks } from "context/webmaster/tasks";

import useResponsive from "libs/helpers/useResponsive";

import DashboardContentLayout from "components/layouts/DashboardContentLayout";
import { TasksTable, TasksTiles } from "page_components/webmaster/tasks";
import { WebsiteInfoModal } from "page_components/shared/tasks/modals";
import {
  StatusExplanation,
  PriorityExplanation,
} from "page_components/shared/tasks/explanations";

const actions = [
  {
    type: "send_notification",
  },
];

const Tasks = () => {
  return (
    <TasksProvider>
      <TasksContent />
    </TasksProvider>
  );
};

const TasksContent = () => {
  const { max } = useResponsive();
  const { t } = useTranslation();

  const { init_loading } = useTasks();

  const [websiteInfoId, setWebsiteInfoId] = useState(null);
  const [explanation, setExplanation] = useState(null);

  return (
    <DashboardContentLayout
      header={{
        label: t("Tasks"),
        description: t("Task list to be completed."),
      }}
      loading={init_loading}
      actions={actions}
    >
      {!max.lg ? (
        <TasksTable
          setWebsiteInfoId={setWebsiteInfoId}
          setExplanation={setExplanation}
        />
      ) : (
        <TasksTiles
          setWebsiteInfoId={setWebsiteInfoId}
          setExplanation={setExplanation}
        />
      )}

      <StatusExplanation
        isOpen={explanation === "status"}
        onClose={() => setExplanation(null)}
      />
      <PriorityExplanation
        isOpen={explanation === "priority"}
        onClose={() => setExplanation(null)}
      />
      <WebsiteInfoModal
        id={websiteInfoId}
        isOpen={!!websiteInfoId}
        onClose={() => setWebsiteInfoId(null)}
      />
    </DashboardContentLayout>
  );
};

export default Tasks;
